var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trigger-the-setting details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" }
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                class: _vm.canSelectGrid,
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "column-defs": _vm.columnDefs,
                  "show-side-bar": false,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false,
                  "min-height": "100%",
                  "grid-style": "min-width: 220px;width:100%;height:100%;"
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticStyle: { "margin-left": "20px", "margin-top": "20px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { width: "320px", "margin-bottom": "30px" }
                    },
                    [
                      !_vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.toEdit }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EditTo")))]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.toSave }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.toCancel }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.isEdit,
                          label: _vm.$t(
                            "AutomaticRelease.ApplyBranchOfficeSettings"
                          )
                        },
                        model: {
                          value: _vm.form.configEnable,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "configEnable", $$v)
                          },
                          expression: "form.configEnable"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "340px",
                          height: "100%",
                          "border-right": "2px solid #040404"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "320px" } },
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("div", { staticClass: "bordered-div" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AutomaticRelease.TriggerTheNode"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("div", { staticClass: "bordered-div" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Enable"))
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    attrs: { disabled: !_vm.readonly },
                                    model: {
                                      value: _vm.form.setting,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "setting", $$v)
                                      },
                                      expression: "form.setting"
                                    }
                                  },
                                  _vm._l(_vm.releaseSettings, function(item) {
                                    return _c(
                                      "el-row",
                                      {
                                        key: item.code,
                                        staticStyle: { width: "320px" }
                                      },
                                      [
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "bordered-div",
                                            attrs: { span: 12 }
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isZh
                                                    ? item.chineseName
                                                    : item.englishName
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "bordered-div",
                                            attrs: { span: 12 }
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              { attrs: { label: item.code } },
                                              [_c("br")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "340px",
                          height: "100%",
                          "margin-left": "30px"
                        }
                      },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: !_vm.readonly,
                            label: _vm.$t(
                              "AutomaticRelease.ScheduledPollingTriggersAutomaticOrderVerification"
                            )
                          },
                          model: {
                            value: _vm.form.autoEnable,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "autoEnable", $$v)
                            },
                            expression: "form.autoEnable"
                          }
                        }),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "5px" } },
                              [_vm._v(_vm._s(_vm.$t("AutomaticRelease.daily")))]
                            ),
                            _c("el-time-select", {
                              attrs: {
                                disabled: !_vm.readonly,
                                "picker-options": _vm.pickerOptions
                              },
                              model: {
                                value: _vm.form.autoTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "autoTime", $$v)
                                },
                                expression: "form.autoTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }